export const SUBMARKET_CODE_MAX_LENGTH = 3;
export const submarketCodeValidator = (t) => (input) => {
    const minLength = 2;
    let err = null;
    if (input.length < minLength) {
        err = t('submarkets.validation.submarket-code-too-short', { minLength });
    } else if (input.length > SUBMARKET_CODE_MAX_LENGTH) {
        err = t('submarkets.validation.submarket-code-too-long', { maxLength: SUBMARKET_CODE_MAX_LENGTH });
    } else if (!input.match(/^[a-zA-Z]*$/)) {
        err = t('submarkets.validation.submarket-code-only-letters');
    }
    return err;
};

export const SUBMARKET_NAME_MAX_LENGTH = 128;
export const submarketNameValidator = (t) => (input) => {
    let err = null;
    if (input.trim().length === 0) {
        err = t('submarkets.validation.submarket-name-empty');
    } else if (input.length > SUBMARKET_NAME_MAX_LENGTH) {
        err = t('submarkets.validation.submarket-name-too-long', { maxLength: SUBMARKET_NAME_MAX_LENGTH });
    }
    return err;
};
